import { useMemo } from "react";
import { ColumnDef } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";
import { ModelSummaryDto } from "@/client";

/**
 * Returns column definitions for model selection tables.
 * Note: Does not include the select column - use with singleSelectColumn from data-table.
 */
export const useModelSelectionColumns = (): ColumnDef<
  ModelSummaryDto,
  unknown
>[] => {
  const { t } = useTranslation();

  return useMemo(() => {
    const columns: ColumnDef<ModelSummaryDto, unknown>[] = [
      {
        id: "name",
        header: t("modelName"),
        accessorKey: "name",
        meta: { disablePreview: true },
        size: 200,
        cell: ({ cell }) => {
          const name = cell.getValue() as string;
          return <span className="truncate">{name}</span>;
        },
      },
      {
        id: "type",
        header: t("type"),
        accessorKey: "type",
        meta: { disablePreview: true },
        size: 80,
        cell: ({ cell }) => {
          const type = cell.getValue() as string;
          return <span className="truncate">{t(type)}</span>;
        },
      },
      {
        id: "role",
        header: t("role"),
        accessorKey: "role",
        meta: { disablePreview: true },
        size: 80,
        cell: ({ cell }) => {
          const role = cell.getValue() as string;
          return <span className="truncate">{t(role)}</span>;
        },
      },
    ];
    return columns;
  }, [t]);
};
